import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import cookie from "js-cookie";
import { getAnalytics as _getAnalytics } from "@miro-site/analytics";
var anonymousIdInterval;
var STATUSES;
(function(STATUSES) {
    STATUSES["loading"] = "loading";
    STATUSES["ready"] = "READY";
    STATUSES["error"] = "ERROR";
})(STATUSES || (STATUSES = {}));
var initialValue = {
    status: STATUSES.loading,
    isLoading: true
};
var SplitIoContext = /*#__PURE__*/ React.createContext([
    initialValue,
    null
]);
export var SplitIoProvider = function(props) {
    var isBot = function isBot() {
        var userAgent = navigator.userAgent;
        var regexp = /bot|crawl|slurp|spider|mediapartners|go-http-client|apache|axios|ahc/i;
        return !!(userAgent && userAgent.match(regexp));
    };
    var children = props.children, _$_getAnalytics = props.getAnalytics, getAnalytics = _$_getAnalytics === void 0 ? _getAnalytics : _$_getAnalytics, _authorizationKey = props.authorizationKey, authorizationKey = _authorizationKey === void 0 ? process.env.NEXT_PUBLIC_SPLITIO_CLIENT_KEY : _authorizationKey, _triesLimit = props.triesLimit, triesLimit = _triesLimit === void 0 ? 20 : _triesLimit;
    var ref = useState(initialValue), splitIOState = ref[0], setSplitIOState = ref[1];
    var ref1 = useState(null), client = ref1[0], setClient = ref1[1];
    useEffect(function() {
        if (isBot()) {
            setSplitIOState({
                status: STATUSES.error,
                error: "Crawler / bot detected"
            });
        } else {
            setSplitIOState({
                status: STATUSES.loading,
                error: ""
            });
            var tries = 0;
            anonymousIdInterval = window.setInterval(function() {
                if (tries >= triesLimit) {
                    setSplitIOState({
                        status: STATUSES.error,
                        error: "Id cookie wasn't found"
                    });
                    clearInterval(anonymousIdInterval);
                    return;
                }
                var anonymousId = cookie.get("ajs_anonymous_id");
                if (typeof anonymousId === "string" && anonymousId.length) {
                    clearInterval(anonymousIdInterval);
                    initSplitIo(anonymousId.replace(/"/g, ""));
                }
                tries++;
            }, 50);
        }
        function initSplitIo(anonymousId) {
            return _initSplitIo.apply(this, arguments);
        }
        function _initSplitIo() {
            _initSplitIo = _async_to_generator(function(anonymousId) {
                var analytics;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            try {
                                analytics = getAnalytics();
                            } catch (e) {
                                setSplitIOState({
                                    status: STATUSES.error,
                                    error: "Analytics library wasn't initialized"
                                });
                                return [
                                    2
                                ];
                            }
                            // Init Split on client-side
                            return [
                                4,
                                _async_to_generator(function() {
                                    var ExperimentationClient, experimentation, _analytics, e;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (window.split) {
                                                    return [
                                                        2
                                                    ];
                                                }
                                                return [
                                                    4,
                                                    import("@mirohq-internal/experimentation-core")
                                                ];
                                            case 1:
                                                ExperimentationClient = _state.sent().ExperimentationClient;
                                                experimentation = new ExperimentationClient();
                                                _state.label = 2;
                                            case 2:
                                                _state.trys.push([
                                                    2,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                return [
                                                    4,
                                                    experimentation.initFactory({
                                                        config: {
                                                            authorizationKey: authorizationKey,
                                                            traffic: {
                                                                defaultTrafficType: "anonymous_user",
                                                                anonymousUserKey: anonymousId
                                                            },
                                                            analytics: {
                                                                sendEvent: function() {
                                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                                                        args[_key] = arguments[_key];
                                                                    }
                                                                    return (_analytics = analytics).sendCustomEvent.apply(_analytics, _to_consumable_array(args));
                                                                }
                                                            }
                                                        },
                                                        advancedSettings: {
                                                            storage: {
                                                                type: "MEMORY"
                                                            }
                                                        }
                                                    })
                                                ];
                                            case 3:
                                                _state.sent();
                                                return [
                                                    4,
                                                    experimentation.getClient().ready()
                                                ];
                                            case 4:
                                                _state.sent();
                                                setSplitIOState({
                                                    status: STATUSES.ready,
                                                    error: ""
                                                });
                                                setClient(experimentation);
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                e = _state.sent();
                                                setSplitIOState({
                                                    status: STATUSES.error,
                                                    error: "Experimentation Client wasn't initialized"
                                                });
                                                setClient(experimentation);
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 6:
                                                window.split = experimentation;
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _initSplitIo.apply(this, arguments);
        }
    }, []);
    return /*#__PURE__*/ _jsx(SplitIoContext.Provider, {
        value: [
            _object_spread_props(_object_spread({}, splitIOState), {
                isLoading: splitIOState.status == STATUSES.loading
            }),
            client
        ],
        children: children
    });
};
export var useSplitIo = function() {
    return React.useContext(SplitIoContext);
};
export var useTreatment = function(name, attrs) {
    var ref = _sliced_to_array(useSplitIo(), 2), isLoading = ref[0].isLoading, client = ref[1];
    var ref1 = useState({}), mockTreatments = ref1[0], setMockTreatments = ref1[1];
    useEffect(function() {
        var getMockTreatmentsFromUrl = function() {
            var treatments = {};
            var treatmentPrefix = "split_exp_";
            if (location === null || location === void 0 ? void 0 : location.search) {
                var searchParams = new URLSearchParams(location.search);
                searchParams.forEach(function(value, param) {
                    if (param.startsWith(treatmentPrefix)) {
                        var key = param.slice(treatmentPrefix.length);
                        treatments[key] = value;
                    }
                });
                setMockTreatments(treatments);
            }
        };
        if ("object" !== "undefined") {
            getMockTreatmentsFromUrl();
        }
    }, []);
    var getMockTreatment = function(name) {
        return mockTreatments[name];
    };
    var ref2;
    var treatment = (ref2 = getMockTreatment(name)) !== null && ref2 !== void 0 ? ref2 : client === null || client === void 0 ? void 0 : client.getTreatment(name, attrs);
    return [
        treatment,
        isLoading
    ];
};
